import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

const BRIDGE_REHAB_INVITES = [
  {
    id: "invite_bridge_cna_001",
    email: "cna1@bridgerehab.com",
    displayName: "Maria Lopez",
    position: "CNA",
  },
  {
    id: "invite_bridge_cna_002",
    email: "cna2@bridgerehab.com",
    displayName: "Angela Brooks",
    position: "CNA",
  },
  {
    id: "invite_bridge_lvn_001",
    email: "lvn1@bridgerehab.com",
    displayName: "Peter Mensah",
    position: "LVN",
  },
  {
    id: "invite_bridge_lvn_002",
    email: "lvn2@bridgerehab.com",
    displayName: "Grace Johnson",
    position: "LVN",
  },
];

export async function seedBridgeRehabWorkerInvites() {
  let count = 0;

  for (const invite of BRIDGE_REHAB_INVITES) {
    await setDoc(
      doc(db, "invites", invite.id),
      {
        email: invite.email,
        displayName: invite.displayName,

        role: "worker",
        platformRole: "worker",

        workerType: invite.position,
        position: invite.position,
        primaryRole: invite.position,
        positions: [invite.position],
        _validTypes: [invite.position],

        facilityId: "bridge_rehab",
        facilityIds: ["bridge_rehab"],

        tenantId: "dogebridge",
        tenantName: "DogeBridge Staffing",

       status: "invited",
inviteStatus: "pending",
invitationStatus: "pending",

registrationStatus: "invited",
onboardingStatus: "invited",
workerStatus: "invited",
complianceStatus: "not_started",
canAccessOnboarding: false,

        archived: false,

        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );

    count++;
  }

  return count;
}